import type { ReactElement } from "react";
import { CmtsOperationalReadinessContainer } from "../../core/containers/domain/auditsecurityRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsOperationalReadinessContainer runtime={props.runtime} />;
}

export default Component;
